import axios from "axios";
import React, { useEffect, useState  } from "react";
import * as ReactRedux from "react-redux";
import {
  affiliateGlobalSearchBox, affiliateStandaloneGlobalSearchBox,
  globalStandaloneSearchBox,
  globalStandaloneSearchBoxBusiness,
  globalStandaloneSearchBoxPro
} from "../../controllers/seachBoxControllers";
import {AllTabIdNames, isRecordProduct, isRecordProductSupport, renderRating, Section_Click} from "../../utils/utils";
import { InteractiveResult } from "../SearchResults/SearchListing/InteractiveResult";
import Picture from "../SearchResults/SearchListing/Picture";


function TopResults(props: any) {
  const activeTab = document
    .querySelector(".nav-link.active")
    ?.getAttribute("id");
  let searchBox = globalStandaloneSearchBox;
  switch (activeTab) {
    case AllTabIdNames.proTab:
      searchBox = globalStandaloneSearchBoxPro;
      break;
    case AllTabIdNames.businessTab:
      searchBox = globalStandaloneSearchBoxBusiness;
      break;
  }
  const {isSafari, results, resultsBySuggestion, firstSuggestion, isAutoCorrected} = props;

  function combineProductAndSupportRecord(nextValue: any, existingValue: any, nextValueIndex: number) {
    let baseRecord;
    if (isRecordProduct(existingValue)) {
      baseRecord = {...existingValue};
      if (isRecordProductSupport(nextValue)) {
        baseRecord.raw = {...baseRecord.raw, spdp_url : nextValue.raw.clickableuri}
      }
    } else if (isRecordProduct(nextValue)) {
      baseRecord = {...nextValue, orgIndex: nextValueIndex};
      if (isRecordProductSupport(existingValue)) {
        baseRecord.raw = {...baseRecord.raw, spdp_url : existingValue.raw.clickableuri}
      }
    } else {
      baseRecord = {...existingValue};
    }
    return baseRecord;
  }

  function filterUniqueResults(results: any[]) {
    let finalResults : any[] = [];
    let uniqueSkus = new Map();
    results.map((value: any, index : number) => {
      let eight_digits_sku : String = value?.raw?.eight_digits_sku;
      let item = uniqueSkus.get(eight_digits_sku);
      if (item) {
        uniqueSkus.set(eight_digits_sku, combineProductAndSupportRecord(value, item, index));
      } else {
        if (isRecordProductSupport(value)) {
          uniqueSkus.set(eight_digits_sku, {...value, orgIndex: index, raw: {...value.raw, spdp_url: value.raw.clickableuri}});
        } else {
          uniqueSkus.set(eight_digits_sku, {...value, orgIndex: index});
        }
      }
    });
    uniqueSkus.forEach((value, key) => finalResults.push(value));
    return finalResults.slice(0, 3);
  }

  const resultList = results.length > 0 ? results : resultsBySuggestion.length > 0 ? resultsBySuggestion : [];
  let uniqueResults = filterUniqueResults(resultList);

  const [productInfo, setProductInfo]: any = useState([]);
  const [firstTimeCalled, setFirstTimeCall]: any = useState(true);
  const [productCompare, setProductCompare]: any = useState([]);
  const [isCallMagentoApiDone, setIsCallMagentoApiDone]: any = useState(true);

  // Get price from Magento to add to the current context. Use for analytic and click event.
  if (uniqueResults.length > 0) {
    const eightSkuArr: string[] = [];
    uniqueResults.forEach((value) =>
        value.raw.eight_digits_sku && eightSkuArr.push(value.raw.eight_digits_sku)
    );
    const containEvery = eightSkuArr?.every(item => productCompare.includes(item));
    if (!containEvery) {
        setProductCompare(eightSkuArr);
        setFirstTimeCall(true);
    }
    if (firstTimeCalled) {
      setFirstTimeCall(false);
      const skusArray: string[] = [];
      uniqueResults.forEach((value, key) =>
        value.raw.sku ? skusArray.push(value.raw.sku) : skusArray.push("")
      );
      if (skusArray.length > 0 && skusArray.length <= 3) {
        const stringConvert: string = skusArray.reduce((stringconverttotal, sku) => (stringconverttotal + `"${sku}"` + ","), "");
        const domain = `${
          (window.location.hostname === "localhost"
            ? "https://webqa.usa.canon.com"
            : window.location.origin) + "/shop/graphql?"
        }`;
        let query = `query={productListInfo(skus:[${stringConvert}]) {products{name sku product_url eight_digits_sku price compatibility_url}}}`;
        setIsCallMagentoApiDone(false);
        axios.get(`${domain + query}`)
            .then(res => setProductInfo(res.data.data?.productListInfo?.products ? res.data.data.productListInfo.products : []))
            .finally(() => {
              setIsCallMagentoApiDone(true);
            })
      }
    }
  }

  const isRenderedTopResults = (props.isAffiliate && !isAutoCorrected || !props.isAffiliate) &&
      (results.length > 0 || results.length == 0 && !firstSuggestion);

  return (
    <div className="right-side-content">
      {
        isRenderedTopResults && isCallMagentoApiDone && (
          <div className="title">
            TOP RESULTS FOR "
            <span className="insert-search-term">
              {props.isAffiliate ? affiliateStandaloneGlobalSearchBox.state.value : searchBox.state.value}
            </span>
            "
          </div>
        )
      }
      {((props.isAffiliate && isAutoCorrected) || (results.length == 0 && uniqueResults.length > 0)) && isCallMagentoApiDone && (
        <>
        <div className="title">
        No result for "
        <span className="insert-search-term">
          {props.isAffiliate
            ? affiliateStandaloneGlobalSearchBox.state.value
            : searchBox.state.value}
        </span>
        "
      </div>
      <div className="title">
      Top results for suggested term "
      <span className="insert-search-term">
        {firstSuggestion}
      </span>
      "
    </div>
        </>
      )}
      <div className="product-results">
        {isCallMagentoApiDone && uniqueResults &&
            uniqueResults.map((result: any, index: any) => {
              var magentoTopResult =  productInfo.length > 0 ?
                  productInfo.filter((item: any) => item.eight_digits_sku == result.raw.eight_digits_sku)[0] : null;
              return (
            <div className="search-result-parent-container" key={result.orgIndex}>
              <div className="search-result">
              <InteractiveResult
                  sectionClick={Section_Click.TOP_RESULTS}
                  isAffiliate={props.isAffiliate}
                  product_use={true}
                  result={result}
                  price={productInfo?.length ? productInfo[index]?.price : null}
                >
                  <Picture
                    thumbnailSrc={result.raw.thumbnail || result.raw.aem_thumbnail}
                    altText={result?.raw?.title ? (isSafari?result?.raw?.title.substr(0,12)+"...":result?.raw?.title ) : ""}
                    isSafari={isSafari}
                    altTextTitle={isSafari && result?.raw?.title ? result?.raw?.title : ''}
                    productClass="item-image"
                  />
                </InteractiveResult>
                <div className="item-details">
                  {props.highlightedValue && props.highlightedValue.length > 0 && (
                    <div className="result item-details-title">
                      <InteractiveResult
                        sectionClick={Section_Click.TOP_RESULTS}
                        isAffiliate={props.isAffiliate}
                        highlightedValue={props.highlightedValue[result.orgIndex]}
                        product_use={true}
                        result={result}
                        price={productInfo?.length ? productInfo[index]?.price : null}
                      />
                    </div>
                  )}
                  {(result.raw?.bv_avg_product_rating === 0 ||
                    result.raw?.bv_avg_product_rating) && (
                    <div className="inline-rating">
                      <div
                        className="stars-rating"
                        dangerouslySetInnerHTML={renderRating(
                          result.raw.bv_avg_product_rating
                        )}
                      ></div>
                      {(result.raw?.bv_number_of_reviews === 0 ||
                        result.raw?.bv_number_of_reviews) && (
                        <div className="number-reviews">
                          {result.raw?.bv_number_of_reviews}
                        </div>
                      )}
                    </div>
                  )}
                  {props.isAffiliate ? (
                    <div className="search-result-extra-link-container">
                      {result.raw.product_url && !result.raw.discontinued_product && (
                        <div className="search-shop-link">
                          <button className="button-shop">
                            <InteractiveResult
                              sectionClick={Section_Click.TOP_RESULTS}
                              classList="a-button-shop"
                              isAffiliate={props.isAffiliate}
                              product_use={true}
                              result={result}
                            >
                              SHOP
                            </InteractiveResult>
                          </button>
                        </div>
                      )}
                        {result.raw.product_type != "bundle" && result.raw.product_url && magentoTopResult && magentoTopResult.compatibility_url && (
                            <div className="search-shop-link">
                                <button className="button-shop">
                                    <InteractiveResult
                                        sectionClick={Section_Click.TOP_RESULTS}
                                        classList="a-button-shop"
                                        isAffiliate={props.isAffiliate}
                                        product_compatibility={true}
                                        result={result}
                                        compatibilityUrl={magentoTopResult.compatibility_url}
                                    >
                                        COMPATIBILITY
                                    </InteractiveResult>
                                </button>
                            </div>
                        )}
                    </div>
                  ) : (
                    <div className="search-result-extra-link-container">
                      {result.raw.product_url && !result.raw.discontinued_product && (
                        <div className="search-shop-link">
                          <InteractiveResult
                            sectionClick={Section_Click.TOP_RESULTS}
                            isAffiliate={props.isAffiliate}
                            product_use={true}
                            result={result}
                          >
                            SHOP
                          </InteractiveResult>
                          <div className="right-arrow-div"></div>
                        </div>
                      )}
                      {result.raw.spdp_url && (
                        <div className="search-support-link">
                          <InteractiveResult sectionClick={Section_Click.TOP_RESULTS} spdp={true} result={result}>
                            SUPPORT
                          </InteractiveResult>
                          <div className="right-arrow-div"></div>
                        </div>
                      )}
                      {result.raw.product_type != "bundle" && result.raw.product_url && magentoTopResult && magentoTopResult.compatibility_url && (
                         <div className="search-shop-compatibility">
                             <InteractiveResult
                                    sectionClick={Section_Click.TOP_RESULTS}
                                    isAffiliate={props.isAffiliate}
                                    product_compatibility={true}
                                    result={result}
                                    compatibilityUrl={magentoTopResult.compatibility_url}
                             >
                                 COMPATIBILITY
                             </InteractiveResult>
                             <div className="right-arrow-div"></div>
                         </div>
                       )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )})}
      </div>
    </div>
  );
}

export default TopResults;
